import { render, staticRenderFns } from "./PropertySelectMenu.vue?vue&type=template&id=ba767a58"
import script from "./PropertySelectMenu.vue?vue&type=script&lang=ts"
export * from "./PropertySelectMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports